import React from 'react';
import styles from './DotIndicator.styles.js';

export default function DotIndicator({ color }) {
  return <div style={{ ...styles.stateIndicator, backgroundColor: color }} />;
}
